import { Loader2 } from "lucide-react";

interface Props {
  answer: string | null;
  action: { type: string; path: string; label: string } | null;
  isLoading: boolean;
  onNavigate: (path: string) => void;
}

export default function PaletteAIAnswer({ answer, action, isLoading, onNavigate }: Props) {
  if (!isLoading && !answer) return null;

  return (
    <div className="mx-3 my-2 p-4 rounded-xl bg-[#B8860B]/5 border border-[#B8860B]/20">
      <div className="text-[10px] uppercase tracking-wider text-[#B8860B]/60 mb-2 font-medium">
        AI Answer
      </div>
      {isLoading ? (
        <div className="flex items-center gap-2 text-white/50 text-sm">
          <Loader2 className="w-4 h-4 text-[#B8860B] animate-spin" />
          <span>Thinking...</span>
        </div>
      ) : (
        <>
          <p className="text-sm text-white/80 whitespace-pre-wrap">{answer}</p>
          {action && (
            <button
              onClick={() => onNavigate(action.path)}
              className="mt-3 text-xs text-[#B8860B] hover:underline cursor-pointer"
            >
              {action.label} →
            </button>
          )}
        </>
      )}
    </div>
  );
}
